import { initializeApp } from "firebase/app";
import { getDatabase } from "firebase/database";

const firebaseConfig = {
  apiKey: "AIzaSyAR8U6aCV8YIGs_VCz2bY3venO9194yD_U",
  authDomain: "my-first-project-cebc3.firebaseapp.com",
  databaseURL: "https://my-first-project-cebc3-default-rtdb.firebaseio.com",
  projectId: "my-first-project-cebc3",
  storageBucket: "my-first-project-cebc3.appspot.com",
  messagingSenderId: "15531968272",
  appId: "1:15531968272:web:8d2ec27e043cbe187c8795",
  measurementId: "G-98KXM33BE0"
};

const app = initializeApp(firebaseConfig);

export const database = getDatabase(app);